import React from "react";
import {
  LocationOn,
  Email,
  Phone,
  Facebook,
  Instagram,
  YouTube
} from "@mui/icons-material";
import "../styles/Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h2 className="footer-heading">ஈரோடு புத்தகத் திருவிழா</h2>
          <p>2025 © அனைத்து உரிமைகளும் பாதுகாக்கப்பட்டவை.</p>
        </div>

        <div className="footer-section">
          <p>
            <LocationOn className="footer-icon" /> A-47, சம்பத் நகர், ஈரோடு -
            638 011.
          </p>
          <p>
            <Phone className="footer-icon" /> 0424 2269186
          </p>
          <p>
            <Email className="footer-icon" /> erodebookfest@gmail.com
          </p>
        </div>

        <div className="footer-section">
          <p>எங்களை பின்தொடரவும்:</p>
          <div className="footer-socials">
            <a
              href="https://www.facebook.com/share/16gTkLiZqt/"
              className="footer-link"
            >
              <Facebook />
            </a>
            <a
              href="https://www.instagram.com/makkalsinthanaiperavai?igsh=MTh4OXpsYzFidGczZQ=="
              className="footer-link"
            >
              <Instagram />
            </a>
            <a
              href="https://youtube.com/@makkalsinthanaiperavai?feature=shared"
              className="footer-link"
            >
              <YouTube />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
